import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { MinusIcon, PlusIcon } from '../Icons';
import { useIntl } from '../../providers';

interface MoreInformationButtonProps {
    onClick?: () => void;
    href?: string;
    collapsed?: boolean;
}

const useStyles = createUseStyles({
    moreInformationButton: {
        display: 'inline-block',
        color: 'var(--primary-color) !important',
        position: 'relative',
        userSelect: 'none',
        background: 'none',
        border: 'none',
        appearance: 'none',
        cursor: 'pointer',
        paddingBlock: '1px',
        paddingInline: '6px',
        textAlign: 'center',
        '&::after': {
            display: 'inline-block',
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            backgroundColor: 'var(--primary-color)',
            height: '2px',
            width: '10px',
            visibility: 'hidden',
            transition: 'all 0.2s cubic-bezier(0.5, 0, 0.5, 1)',
        },
        '&:hover': {
            textDecoration: 'none',
            '&::after': {
                visibility: 'visible',
                width: '100%',
            },
        },
    },
    link: {
        textDecoration: 'none',
    },
});

const MoreInformationButton: React.FC<MoreInformationButtonProps> = ({
    onClick,
    href,
    collapsed = true,
}: MoreInformationButtonProps) => {
    const classes = useStyles();
    const { translate } = useIntl();

    const label = collapsed ? (
        <>
            <PlusIcon /> {translate('productCard.action.moreInformation', 'more information')}
        </>
    ) : (
        <>
            <MinusIcon /> {translate('productCard.action.showLess', 'show less')}
        </>
    );

    if (href) {
        return (
            <a href={href} className={`${classes.moreInformationButton} ${classes.link}`} onClick={onClick}>
                {label}
            </a>
        );
    }

    return (
        <button onClick={onClick} className={classes.moreInformationButton}>
            {label}
        </button>
    );
};

export default React.memo(MoreInformationButton);
